import { Badge, type BadgeVariant } from '../../../../components/ui/Badge/Badge';
import type { SkipInventoryStatus } from '../../../../types/api';

const STATUS_LABELS: Record<SkipInventoryStatus, string> = {
  available: 'Available',
  out: 'Out',
  maintenance: 'Maintenance',
};

const STATUS_VARIANTS: Record<SkipInventoryStatus, BadgeVariant> = {
  available: 'success',
  out: 'warning',
  maintenance: 'muted',
};

export interface SkipInventoryStatusBadgeProps {
  status: SkipInventoryStatus;
}

export function SkipInventoryStatusBadge({ status }: SkipInventoryStatusBadgeProps): JSX.Element {
  return <Badge variant={STATUS_VARIANTS[status]}>{STATUS_LABELS[status]}</Badge>;
}
